module.exports = __webpack_public_path__ + "static/hero-3e98ae7f4f954a2a0c9aff0901d9ff40.png";